import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { UnloadGuard } from 'src/app/core/guards/unload.guard';
import { ChooseDictionaryComponent } from './choose-dictionary/choose-dictionary.component';
import { ChooseLanguageComponent } from './choose-language/choose-language.component';
import { LanguageDetailComponent } from './language-detail/language-detail.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

const routes: Routes = [
  {
    path: 'languages',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: 'select-dictionary', component: ChooseDictionaryComponent },
      { path: ':entityType', component: ChooseLanguageComponent },
      { path: 'detail/:languageId/:entityType', component: LanguageDetailComponent, canDeactivate: [UnloadGuard] },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class LanguageRoutingModule {}
